<template>
  <div class="main_wrap">
    <!-- 活动标题 -->
    <div v-wechat-title="'《魔卡少女樱：回忆钥匙》召回旧友'"></div>

    <Header
      v-if="true"
      :isOnline="1"
      :config="headerConfig"
      :isShowInfo="true"
      :isRecall="true"
    />
    <div class="first-page">
      <div class="title">
        <div class="btn" @click="isShowRules = true"></div>
      </div>
      <div class="recall_btn" @click="isShowMyRecallClick"></div>
      <div class="submit" @click="isShowfillInClick"></div>
    </div>
    <div class="second-page">
      <div class="main">
        <div class="prize_wrap">
          <div class="task_award"></div>
          <div class="big_prize"></div>
          <div class="get_btn" @click="isShowGetDialogClick(5, {})"></div>
        </div>
        <div class="task_bg">
          <div class="task1">登录游戏1次({{ my_role_info.is_login }}/1)</div>
          <div class="task2">
            完成两次全部每日任务({{ my_role_info.two_tasks }}/2)
          </div>
          <div class="task3">
            抽取3次系列盲盒({{ my_role_info.three_lottery }}/3)
          </div>
          <div class="task4">累积出行3次({{ my_role_info.three_walk }}/3)</div>
          <div class="refresh" @click="refreshClick"></div>
          <!-- 任务 -->
          <div class="task_list">
            <div
              :class="index == 0 ? 'captain_wrap' : 'player_wrap'"
              v-for="(item, index) in task_list"
              :key="index"
            >
              <div
                :class="
                  item.account && index == 0
                    ? 'captain'
                    : item.account && index != 0
                    ? 'player'
                    : 'captain join'
                "
                @click="isShowCreateClick(index, item)"
              >
                <div v-if="item.account">
                  尾号<br /><span>{{ item.account }}</span>
                </div>
                <div
                  class="captain_icon"
                  v-if="!item.account && index == 0"
                ></div>
              </div>
              <div :class="!item.account ? 'task grey_out' : 'task'">
                <div :class="taskListRender(1, item)"></div>
                <div :class="taskListRender(2, item)"></div>
                <div :class="taskListRender(3, item)"></div>
                <div :class="taskListRender(4, item)"></div>
              </div>
            </div>
          </div>
          <!-- 领取奖励 -->
          <div class="award_wrap">
            <div
              :class="'award' + (index + 1)"
              v-for="(item, index) in reward_info"
              :key="index"
            >
              <div
                :class="awardListRender(index + 1, item)"
                @click="isShowGetDialogClick(index + 1, item)"
              >
                <div v-if="item.is_get">已领取</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer :gameName="gameName"></Footer>

    <!-- 登录弹窗 -->
    <Login
      v-if="isShowLogin"
      v-on:channelCallback="selectCallback"
      :gameName="gameName"
      :downloadUrl="downloadUrl"
      :loginTypes="loginTypes"
    ></Login>
    <Os
      v-if="isShowOs"
      v-on:selectCallback="selectCallback"
      v-on:logoutCallback="osCancell"
      :gameName="gameName"
      @getSelectInfo="getSelectInfo"
    ></Os>

    <!-- 活动规则弹窗 -->
    <div class="rules-wrap popup_wrap" v-show="isShowRules">
      <transition
        enter-active-class="animated zoomIn"
        leave-active-class="animated zoomOut"
        :duration="{ enter: 1000 }"
      >
        <div class="rules-box popup_wrap-box" v-show="isShowRules">
          <div class="rules_detail_wrap">
            <img
              src="../../../../assets/images/active/sakura/recall/content.png"
              alt=""
            />
          </div>
          <div class="close" @click="isShowRules = false"></div>
          <div class="close-bg" @click="isShowRules = false"></div>
        </div>
      </transition>
    </div>

    <!-- 回归弹窗 -->
    <div class="regression_wrap popup_wrap" v-show="isShowRegression">
      <transition
        enter-active-class="animated zoomIn"
        leave-active-class="animated zoomOut"
        :duration="{ enter: 1000 }"
      >
        <div class="regression_box popup_wrap-box" v-show="isShowRegression">
          <div class="confirm" @click="isShowRegression = false"></div>
          <div class="close" @click="isShowRegression = false"></div>
          <div class="close-bg" @click="isShowRegression = false"></div>
        </div>
      </transition>
    </div>

    <!-- 我的召回码弹窗 -->
    <div class="my_recall_wrap popup_wrap" v-show="isShowMyRecall">
      <transition
        enter-active-class="animated zoomIn"
        leave-active-class="animated zoomOut"
        :duration="{ enter: 1000 }"
      >
        <div class="my_recall_box popup_wrap-box" v-show="isShowMyRecall">
          <div class="recall_num">{{ activeInfo.code }}</div>
          <div
            class="copy_btn"
            @click="onCopy('#clipboard-btn')"
            id="clipboard-btn"
            data-event="复制邀请链接"
            :data-clipboard-text="
              '和我一起回到友枝町吧~完成回归任务还可获得丰厚好礼！绑定回归码：' +
              activeInfo.code +
              '或点击链接：' +
              link +
              '?code=' +
              activeInfo.code +
              '与我组队'
            "
          ></div>
          <div class="close" @click="isShowMyRecall = false"></div>
          <div class="close-bg" @click="isShowMyRecall = false"></div>
        </div>
      </transition>
    </div>

    <!-- 填写召回码弹窗 -->
    <div class="fill_in_wrap popup_wrap" v-show="isShowfillIn">
      <transition
        enter-active-class="animated zoomIn"
        leave-active-class="animated zoomOut"
        :duration="{ enter: 1000 }"
      >
        <div class="fill_in_box popup_wrap-box" v-show="isShowfillIn">
          <div class="recall_num">
            <input type="text" v-model.trim="code" />
          </div>
          <div class="confirm" @click="joinTeamClick(code)"></div>
          <div class="close" @click="isShowfillIn = false"></div>
          <div class="close-bg" @click="isShowfillIn = false"></div>
        </div>
      </transition>
    </div>

    <!-- 创建队伍确认弹窗 -->
    <div class="create_wrap popup_wrap" v-show="isShowCreate">
      <transition
        enter-active-class="animated zoomIn"
        leave-active-class="animated zoomOut"
        :duration="{ enter: 1000 }"
      >
        <div class="create_box popup_wrap-box" v-show="isShowCreate">
          <div class="cancel" @click="isShowCreate = false"></div>
          <div class="confirm" @click="createTeamClick"></div>
          <div class="close" @click="isShowCreate = false"></div>
          <div class="close-bg" @click="isShowCreate = false"></div>
        </div>
      </transition>
    </div>

    <!-- 创建队伍确认弹窗（未流失玩家登录后的弹窗） -->
    <div class="create_wrap1 popup_wrap" v-show="isShowCreate1">
      <transition
        enter-active-class="animated zoomIn"
        leave-active-class="animated zoomOut"
        :duration="{ enter: 1000 }"
      >
        <div class="create_box popup_wrap-box" v-show="isShowCreate1">
          <!-- <div class="cancel" @click="isShowCreate1 = false"></div> -->
          <div class="confirm" @click="isShowCreate1 = false"></div>
          <div class="close" @click="isShowCreate1 = false"></div>
          <div class="close-bg" @click="isShowCreate1 = false"></div>
        </div>
      </transition>
    </div>

    <!-- 创建队伍确认弹窗(回归用户) -->
    <div
      class="create_regression_wrap popup_wrap"
      v-show="isShowCreateRegression"
    >
      <transition
        enter-active-class="animated zoomIn"
        leave-active-class="animated zoomOut"
        :duration="{ enter: 1000 }"
      >
        <div
          class="create_regression_box popup_wrap-box"
          v-show="isShowCreateRegression"
        >
          <div class="cancel" @click="isShowCreateRegression = false"></div>
          <div class="confirm" @click="createTeamClick"></div>
          <div class="close" @click="isShowCreateRegression = false"></div>
          <div class="close-bg" @click="isShowCreateRegression = false"></div>
        </div>
      </transition>
    </div>

    <!-- 加入队伍确认弹窗 -->
    <div class="join_wrap popup_wrap" v-show="isShowJoin">
      <transition
        enter-active-class="animated zoomIn"
        leave-active-class="animated zoomOut"
        :duration="{ enter: 1000 }"
      >
        <div class="join_box popup_wrap-box" v-show="isShowJoin">
          <div class="content">
            欢迎您回到《魔卡少女樱：回忆钥匙》的世界！<br />您的好友（{{
              activeInfo.team_name
            }}）邀请你加入小队<br />完成任务即可获得<span
              >高级盲盒兑换券*10</span
            >
            以及诸多奖品<br /><br />
            请问是否加入？
          </div>
          <div class="cancel" @click="isShowJoin = false"></div>
          <div class="confirm" @click="joinTeamClick(invitationCode)"></div>
          <div class="close" @click="isShowJoin = false"></div>
          <div class="close-bg" @click="isShowJoin = false"></div>
        </div>
      </transition>
    </div>

    <!-- 领取奖励弹窗 -->
    <div class="get_dialog_wrap popup_wrap" v-show="isShowGetDialog">
      <transition
        enter-active-class="animated zoomIn"
        leave-active-class="animated zoomOut"
        :duration="{ enter: 1000 }"
      >
        <div class="get_dialog_box popup_wrap-box" v-show="isShowGetDialog">
          <div class="content">
            奖励将发放至角色【<span
              >{{ userInfo.role_name }}（{{ userInfo.server_name }}）</span
            >】游戏内邮箱。
          </div>
          <div class="confirm" @click="getAwardClick"></div>
          <div class="close" @click="isShowGetDialog = false"></div>
          <div class="close-bg" @click="isShowGetDialog = false"></div>
        </div>
      </transition>
    </div>

    <!-- 领取成功弹窗 -->
    <div class="success_dialog_wrap popup_wrap" v-show="isShowSuccessDialog">
      <transition
        enter-active-class="animated zoomIn"
        leave-active-class="animated zoomOut"
        :duration="{ enter: 1000 }"
      >
        <div
          class="success_dialog_box popup_wrap-box"
          v-show="isShowSuccessDialog"
        >
          <div
            :class="
              task_id == 1
                ? 'icon1'
                : task_id == 2 || task_id == 4
                ? 'icon2'
                : task_id == 3
                ? 'icon3'
                : 'icon4'
            "
          >
            <div class="describe">
              {{
                task_id == 1
                  ? "星之币 × 300"
                  : task_id == 2
                  ? "普通盲盒兑换券 × 10"
                  : task_id == 3
                  ? "S级出行券 × 3"
                  : task_id == 4
                  ? "普通盲盒兑换券 × 20"
                  : "高级盲盒兑换券 × 10"
              }}
            </div>
          </div>
          <div class="close" @click="isShowSuccessDialog = false"></div>
          <div class="close-bg" @click="isShowSuccessDialog = false"></div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import { Toast, Indicator } from "mint-ui";
import Clipboard from "clipboard";
import { mapState, mapMutations, mapActions } from "vuex";
import Os from "@/components/os";
import Login from "@/components/login";
import Header from "../Header/index.vue";
import Footer from "@/components/Footer";
import { headerConfig } from "../headerConfig";
import {
  onGetInitDataAPI,
  onGetHelpInitDataAPI,
  joinTeamAPI,
  createTeamAPI,
  getAwardAPI,
  secretFreeLoginApi,
  updateAPI,
} from "../api";
import { buriedLogger, getRandomString } from "@/utils/utils";

export default {
  name: "sakura-recall",
  components: {
    Header,
    Footer,
    Login,
    Os,
  },

  data() {
    return {
      headerConfig,
      gameName: "sakura",
      downloadUrl: "https://sakura.qingcijoy.com/official/index.html",
      isShowRules: false, // 活动规则弹窗
      isShowRegression: false, // 回归弹窗
      isShowMyRecall: false, // 我的召回码弹窗
      isShowfillIn: false, // 填写召唤码
      isShowCreate: false, // 创建队伍弹窗
      isShowCreate1: false, // 创建队伍确认弹窗（未流失玩家登录后的弹窗）
      isShowCreateRegression: false, // 创建队伍弹窗(回归用户)
      isShowJoin: false, // 加入队伍确认弹窗
      isShowGetDialog: false, // 领取奖励弹窗
      isShowSuccessDialog: false, // 领取成功弹窗
      // 其他数据
      loginTypes: ["sms", "password"],
      // 游戏传过来的参数↓
      game_id: "",
      role_id: "",
      sign: "",
      token: "",
      server_id: "",
      // 游戏传过来的参数↑
      access_token: "",
      code: "", // 召回码
      invitationCode: "", // 邀请码
      task_list: [
        { account: "" },
        { account: "" },
        { account: "" },
        { account: "" },
      ], // 任务列表
      reward_info: [{}, {}, {}, {}], // 奖励列表
      my_role_info: {
        is_login: 0,
        is_loss: 0,
        two_tasks: 0,
        three_lottery: 0,
        three_walk: 0,
      }, // 任务次数详情
      link: "", // 分享链接
      task_id: 0, // 奖励id
      taskDetail: {}, //奖励详情
    };
  },
  created() {
    // 清空store上的用户数据
    // this.setInitActiveInfo();
    // this.setInitUserInfo();
    this.access_token = window.localStorage.getItem("access_token");
    this.invitationCode = this.$route.query.code;
    const { protocol, host } = window.location;
    this.link = `${protocol}//${host}/sakura/recall/enter${getRandomString()}`;

    if (
      this.$route.query.game_id &&
      this.$route.query.role_id &&
      this.$route.query.token
    ) {
      this.game_id = this.$route.query.game_id;
      this.role_id = this.$route.query.role_id;
      this.sign = this.$route.query.sign;
      this.token = this.$route.query.token;
      this.server_id = this.$route.query.server_id;
      this.secretFreeLogin();
    } else {
      if (this.invitationCode) {
        this.helpInitData();
      } else {
        this.reInit();
      }
    }

    // 埋点
    const bl = buriedLogger("sakura", "小樱_召回旧友H5活动");
    this.logger = bl;
  },
  mounted() {
    this.$nextTick(() => {
      this.isSetShare();
    });
  },
  computed: {
    ...mapState(["userInfo", "activeInfo", "isShowLogin", "isShowOs"]),
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        if (!newValue.role_id) {
          // TAG: 注销的时候
        } else if (newValue.role_id !== oldValue.role_id) {
          // TAG: 初始登陆/切换角色的时候
        }
      },
    },
    activeInfo: {
      handler(newValue, oldValue) {
        if (!newValue.task_data) {
          // TAG: 未登录的时候
          this.task_list = [
            { account: "" },
            { account: "" },
            { account: "" },
            { account: "" },
          ];
          this.reward_info = [{}, {}, {}, {}];
          this.my_role_info = {
            is_login: 0,
            is_loss: 0,
            two_tasks: 0,
            three_lottery: 0,
            three_walk: 0,
          };
        } else {
          this.task_list = newValue.task_data.task_list;
          this.reward_info = newValue.task_data.reward_info;
          if (newValue.is_create || newValue.is_join) {
            this.my_role_info = newValue.task_data.my_role_info;
          } else {
            this.my_role_info = {
              is_login: 0,
              is_loss: 0,
              two_tasks: 0,
              three_lottery: 0,
              three_walk: 0,
            };
          }
        }
      },
    },
  },
  methods: {
    // 初始化接口
    reInit() {
      onGetInitDataAPI({ access_token: this.access_token }).then((response) => {
        this.setUserInfo(response.data.user_info);
        this.setActiveInfo(response.data.activity);
        if (response.code == 200) {
          if (
            !response.data.activity.is_create &&
            !response.data.activity.is_join &&
            response.data.activity.is_loss == 1
          ) {
            this.isShowRegression = true;
          } else if (
            response.data.activity.is_loss != 1 &&
            !response.data.activity.is_create &&
            !response.data.activity.is_join
          ) {
            this.isShowCreate1 = true;
          }
        }
      });
    },
    // 初始化接口（帮助页）
    helpInitData() {
      onGetHelpInitDataAPI({
        code: this.invitationCode,
        access_token: this.access_token,
      }).then((response) => {
        if (response.code == 200) {
          this.setUserInfo(response.data.user_info);
          this.setActiveInfo(response.data.activity);
          if (
            !response.data.activity.is_my &&
            !response.data.activity.is_create &&
            !response.data.activity.is_join
          ) {
            this.isShowJoin = true;
          } else if (
            !response.data.activity.is_my &&
            (response.data.activity.is_create || response.data.activity.is_join)
          ) {
            this.onToast("您已加入小队");
            this.$router.replace(`/recall/enter${getRandomString()}`);
          }
        } else {
          if (response.code != 403) {
            this.onToast(response.message);
          } else {
            this.changeLoginPopup(true);
          }
          if (response.code == 404) {
            this.$router.replace(`/recall/enter${getRandomString()}`);
          }
        }
      });
    },
    // 立即召回点击事件
    isShowMyRecallClick() {
      if (!this.userInfo.role_id) {
        return this.changeLoginPopup(true);
      } else if (!this.activeInfo.is_create && !this.activeInfo.is_join) {
        return this.onToast("未绑定小队，请先创建或加入小队！");
      }
      this.isShowMyRecall = true;
    },
    // 填写召回码点击事件
    isShowfillInClick() {
      if (!this.userInfo.role_id) {
        return this.changeLoginPopup(true);
      }
      this.isShowfillIn = true;
    },
    // 创建队伍点击事件
    isShowCreateClick(index, item) {
      if (!this.userInfo.role_id) {
        return this.changeLoginPopup(true);
      } else if (index == 0 && !item.account && this.activeInfo.is_loss == 1) {
        // 点击队长头像且是回归用户
        this.isShowCreateRegression = true;
      } else if (index == 0 && !item.account) {
        // 点击队长头像时
        this.isShowCreate = true;
      } else if (
        !this.activeInfo.is_create &&
        !this.activeInfo.is_join &&
        !item.account &&
        this.activeInfo.is_loss != 1 &&
        index != 0
      ) {
        this.onToast("仅流失玩家可成为队员~");
      } else if (
        !this.activeInfo.is_create &&
        !this.activeInfo.is_join &&
        !item.account
      ) {
        this.onToast("未发现小队队长~");
      } else if (!item.account) {
        this.isShowMyRecall = true;
      }
    },
    // 加入队伍请求
    joinTeamClick(code) {
      if (this.activeInfo.is_create || this.activeInfo.is_join) {
        return this.onToast("很抱歉，您已经入队了！");
      } else if (!code) {
        return;
      } else if (code == this.activeInfo.code) {
        return this.onToast("您无法加入自己的队伍");
      }
      joinTeamAPI({ code: code, access_token: this.access_token }).then(
        (response) => {
          if (response.code == 200) {
            this.onToast("加入队伍成功!");
            if (this.invitationCode) {
              this.helpInitData();
            } else {
              this.reInit();
            }
            this.logger.sum("加入队伍成功_召回");
            this.isShowJoin = false;
            this.isShowfillIn = false;
          } else {
            this.logger.sum("加入队伍失败_召回");
            this.onToast(response.message);
          }
        }
      );
    },
    // 创建队伍请求
    createTeamClick() {
      createTeamAPI({ access_token: this.access_token }).then((response) => {
        if (response.code == 200) {
          this.onToast("创建队伍成功!");
          if (this.invitationCode) {
            this.helpInitData();
          } else {
            this.reInit();
          }
          this.logger.sum("创建队伍成功_召回");
          this.isShowCreate = false;
          this.isShowCreateRegression = false;
        } else {
          this.logger.sum("创建队伍失败_召回");
          this.onToast(response.message);
        }
      });
    },
    // 领取奖励确认弹窗
    isShowGetDialogClick(index, item) {
      this.task_id = index;
      this.taskDetail = item;
      if (!this.userInfo.role_id) {
        return this.changeLoginPopup(true);
      } else if (item.is_get) {
        return this.onToast("您已领取过奖励");
      } else if (!item._get && index != 5) {
        return this.onToast("请先完成任务");
      }
      if (this.task_id == 5) {
        if (!this.activeInfo.task_data.is_complete) {
          return this.onToast("小队未满足完成三人以上全部任务");
        } else if (this.activeInfo.task_data.is_get) {
          return this.onToast("您已领取过奖励");
        }
      }
      this.isShowGetDialog = true;
    },
    // 奖励领取请求
    getAwardClick() {
      this.isShowGetDialog = false;
      // 领大奖的时候
      getAwardAPI({
        task_id: this.task_id,
        access_token: this.access_token,
      }).then((response) => {
        if (response.code == 200) {
          if (this.invitationCode) {
            this.helpInitData();
          } else {
            this.reInit();
          }
          this.isShowSuccessDialog = true;
          this.logger.sum("领取奖励成功_召回");
        } else {
          this.logger.sum("领取奖励失败_召回");
          this.onToast(response.message);
        }
      });
    },
    // 刷新任务信息请求
    refreshClick() {
      if (!this.userInfo.role_id) {
        return this.changeLoginPopup(true);
      }
      Indicator.open();
      updateAPI({
        access_token: this.access_token,
      }).then((response) => {
        if (this.invitationCode) {
          this.helpInitData();
        } else {
          this.reInit();
        }
        Indicator.close();
      });
    },
    // 免密登录请求
    secretFreeLogin() {
      let params = {
        game_id: this.game_id,
        role_id: this.role_id,
        sign: this.sign,
        token: this.token,
        server_id: this.server_id,
      };
      secretFreeLoginApi(params).then((response) => {
        if (response.code == 200) {
          window.localStorage.setItem(
            "access_token",
            response.data.access_token
          );
          this.access_token = response.data.access_token;
          window.location.href = this.link;
          // if (this.invitationCode) {
          //   this.helpInitData();
          // } else {
          //   this.reInit();
          // }
          this.logger.sum("免密登录成功_召回");
        } else {
          this.logger.sum("免密登录失败_召回");
          this.onToast(response.message);
        }
      });
    },
    // 获取选中的角色信息
    getSelectInfo(info, token) {
      this.token = token;
    },
    // 选择角色后
    selectCallback() {
      this.access_token = window.localStorage.getItem("access_token");
      if (this.invitationCode) {
        this.helpInitData();
      } else {
        this.reInit();
      }
    },
    // 区组弹窗注销-相关参数复位
    osCancell() {},
    // 任务列表样式渲染
    taskListRender(index, item) {
      let className = "";
      if (item.task_info && item.task_info[index - 1]._get) {
        className = `finished${index}`;
      } else {
        className = `finished${index} grey_out`;
      }
      return className;
    },
    // 奖励样式渲染
    awardListRender(index, item) {
      let className = "";
      if ((index == 2 || index == 4) && item._get) {
        className = `claimable2`;
      } else if ((index == 2 || index == 4) && !item._get) {
        className = `claimable2 unclaimable`;
      } else if (index == 1 && item._get) {
        className = `claimable1`;
      } else if (index == 1 && !item._get) {
        className = `claimable1 unclaimable`;
      } else if (index == 3 && item._get) {
        className = `claimable3`;
      } else if (index == 3 && !item._get) {
        className = `claimable3 unclaimable`;
      }
      return className;
    },
    // TAG: 其他简易封装的方法
    onToast(config) {
      const curConfig = {
        duration: 1000,
        className: "toasts",
      };
      if (!config) {
        console.error("缺少config参数");
        return false;
      }
      if (typeof config === "string") {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    onCopy(domName) {
      const clipboard = new Clipboard(domName);
      clipboard.on("success", (e) => {
        this.onToast("复制成功");
        this.logger.sum("复制召回码_召回");
        e.clearSelection();
      });

      clipboard.on("error", (e) => {
        this.onToast("复制失败");
      });
    },
    isSetShare() {
      this.setShare({
        link: `https://h5.qingcigame.com/sakura/recall/enter${getRandomString()}`,
        title: "《魔卡少女樱：回忆钥匙》重返梦境",
        imgUrl:
          "https://download4.qcplay.com/qcgame-admin/YWMYeKCInys3RB04Z6PknYSBZKtrxCcqnfLupSwG.jpg",
        desc: "召回好友，共同领取回归大礼！",
      });
    },
    ...mapMutations([
      "changeLoginPopup",
      "changeOsPopup",
      "setInitActiveInfo",
      "setInitUserInfo",
      "setLogger",
      "setUserInfo",
      "setActiveInfo",
    ]),
    ...mapActions(["onInitDataCallback", "setShare"]),
  },
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/sakura/recall/index/index.vue